import { SslStatusByCommerce } from 'ncp-api-supporter';
import { Vue, Component } from 'vue-property-decorator';

const DOMAIN_EXPIRATION_WARN_DUE_DATE = 30;

@Component
export default class DomainSecurityConnectionMixin extends Vue {
  getIsExpiredClose(dueDay: number | null) {
    return !!dueDay && dueDay <= DOMAIN_EXPIRATION_WARN_DUE_DATE;
  }

  getIsSslUnConnect(status: SslStatusByCommerce) {
    return ['UNINSTALLED', 'EXPIRATION'].includes(status);
  }
}
